import { takeLatest, select, put, call } from "redux-saga/effects";
import { saveAs } from "file-saver";
import log from "loglevel";

import axios from "../../utils/axios";
import getEnvParam from "../../utils/getEnvParam";
import { requestDefaultJson } from './helpers';
import { downloadFile } from '../../utils/utilFile';
import messages from "../../assets/i18n";

const requestItems = (pedido, token) => {
    return axios.request({
        method: "POST",
        headers: {
            "Content-Type": "application/graphql",
            "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS"),
            "Authorization": token,
        },
        data: `{
            buscarItensPorPedidoIdParaEtiqueta(idPedido: "${pedido}"){
                items{
                  id
                  codItem
                  packNo
                  detalheItems{
                      descricaoCurta
                  }
                  qtVolume
                  qtCompra
                } 
            }
        }`
    }).then( 
        response => response.status !== 200 ? response : response 
    ).then(
        response => response.data && response.data.data.buscarItensPorPedidoIdParaEtiqueta
    ).catch(error => {
        log.info(error);
        return error
    });
}

const requestItemsBox = (pedido, token) => {
    return axios.request({
        method: "POST",
        headers: {
            "Content-Type": "application/graphql",
            "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS"),
            "Authorization": token,
        },
        data: `{
            buscarItensPorPedidoIdParaSeloCaixa(idPedido: "${pedido}"){
                items{
                  id
                  codItem
                  packNo
                  detalheItems{
                      descricaoCurta
                  }
                  qtVolume
                  qtCompra
                  qtItens
                  tamPacoteSupp
                } 
            }
        }`
    }).then( 
        response => response.status !== 200 ? response : response 
    ).then(
        response => response.data && response.data.data.buscarItensPorPedidoIdParaSeloCaixa
    ).catch(error => {
        log.info(error);
        return error
    });
}

const requestTag = (tipoTag, tipoDeRetorno, pedido, itens, nomeArquivo, multipack, tipoSelo, token, modelo) => {
    return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + '/etiquetas/' + tipoTag, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_ETIQUETA"),
            responseType: 'blob',
            Authorization: token,
        },                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
        data: {
            idPedido: pedido,
            itens: itens,
            nomeArquivo: nomeArquivo,
            multipack: multipack,
            tipoSelo: tipoSelo,
            modelo: modelo
        }
    }).then((response) => {
        if (tipoDeRetorno === "download") {
            const data = response.data;
            const arrNameFileFromServer = response.headers['content-disposition'].split("attachment; filename=")[1].split('.');

            let nameFile

            if (arrNameFileFromServer[1].toLowerCase() === 'txt' || arrNameFileFromServer[1].toLowerCase() === 'zpl') {
                nameFile = `${arrNameFileFromServer[0]}_${pedido}.txt`;
            } else {
                nameFile = `${arrNameFileFromServer[0]}_${pedido}.${arrNameFileFromServer[1]}`;
            }
            
            downloadFile(data, nameFile);
        } 
        return response.data;
    }).catch(error => {        
        log.info(error);
        return error
    });;
};

const requestCustomTag = (payload, token) => {

    const {
        tipoTag,
        tipoDeRetorno,
        pedido,
        itens,
        nomeArquivo,
        customOptions
    } = payload

    return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + '/etiquetas/' + tipoTag, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_ETIQUETA"),
            responseType: 'blob',
            Authorization: token,
        },                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
        data: {
            idPedido: pedido,
            itens: itens,
            nomeArquivo: nomeArquivo,
            tipoEtiqueta: customOptions.tipo
        }
    }).then((response) => {
        if (tipoDeRetorno === "download") {
            const data = response.data;
            const arrNameFileFromServer = response.headers['content-disposition'].split("attachment; filename=")[1].split('.');

            let nameFile

            if (arrNameFileFromServer[1].toLowerCase() === 'txt' || arrNameFileFromServer[1].toLowerCase() === 'zpl') {
                nameFile = `${arrNameFileFromServer[0]}_${pedido}.txt`;
            } else {
                nameFile = `${arrNameFileFromServer[0]}_${pedido}.${arrNameFileFromServer[1]}`;
            }

            downloadFile(data, nameFile);
        } 
        return response.data;
    }).catch(error => {        
        log.info(error);
        return error
    });
};

const requestTagToPdfFronApi = (tipoTag, tipoDeRetorno, pedido, itens, token) => {
    return requestDefaultJson({
        URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/etiquetas/gerar/pdf/Reports/etiqueta_camicado_pdf.pdf',
        method: 'POST',
        headers: {
            "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_ETIQUETA"),
            Authorization: token,
        },
        responseType: 'blob',
        data: {
            idPedido: pedido,
            itens: itens,
        }
    });
};

function* getItems(payload) {
    try {
        const authentication = state => state.authentication;
		
        const { token } = yield select(authentication);
        const lang = yield select(state => state.language.name);
        
        let data = yield call(requestItems, payload.pedido,token)
        
        if (data && data.items) {
            yield put({ type: "ITEM_LIST", payload: data.items});
        } else {
            yield put({ 
                type: "SET_TAG_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].tagToast.itemInternalError,
                    messageType: "toast-error"
            }});
        }
        
    } catch (error) {
        const lang = yield select(state => state.language.name);

        yield put({ 
            type: "SET_TAG_TOAST", 
            payload: {
                showToast: true,
                message: messages[lang].tagToast.itemInternalError,
                messageType: "toast-error"
        }});
        log.info(error);
    }
}

function* getItemsBox(payload) {
    try {
        const authentication = state => state.authentication;
		
        const { token } = yield select(authentication);
        const lang = yield select(state => state.language.name);
        
        let data = yield call(requestItemsBox, payload.pedido,token)

        if (data && data.items) {
            yield put({ type: "ITEM_LIST_BOX", payload: data.items});
        } else {
            yield put({ 
                type: "SET_TAG_TOAST", 
                payload: {
                    showToast: true,
                    message: messages[lang].tagToast.itemInternalError,
                    messageType: "toast-error"
            }});
        }
    } catch (error) {
        const lang = yield select(state => state.language.name);

        yield put({ 
            type: "SET_TAG_TOAST", 
            payload: {
                showToast: true,
                message: messages[lang].tagToast.itemInternalError,
                messageType: "toast-error"
        }});
        log.info(error);
    }
}

function* getTag({payload}) {
    try {
        let data;
        const { token } = yield select(state => state.authentication);

        yield put({ type: "GET_TAGS_LOADING", payload: true });

        if (payload.customOptions) {
            data = yield call(requestCustomTag, payload, token);
        } else {
            if(payload.tipoDeRetorno !== 'generatePDF') {
                data = yield call(requestTag, payload.tipoTag, payload.tipoDeRetorno, payload.pedido, payload.itens, payload.nomeArquivo, payload.multipack ? payload.multipack : false, payload.tipoSelo, token, payload.modelo);
            } else {
                data = yield call(requestTagToPdfFronApi, payload.tipoTag, payload.tipoDeRetorno, payload.pedido, payload.itens, token);
            }
        }
        
        if (data.status) {
            yield put({ 
                type: "SET_TAG_TOAST", 
                payload: {
                    showToast: true,
                    message: data.data,
                    messageType: "toast-error"
            }});
        } else {
            if (payload.tipoDeRetorno === "print") {
                yield put({ type: "PRINTER_WRITE", data });
            } else if (payload.tipoDeRetorno === "generatePDF") {
                saveAs(data, `${payload.nomeArquivoPdf}_${payload.pedido}.pdf`);
            }
            yield put({ type: "GET_TAGS_SUCCESS", tags: data });
        }

        yield put({ type: "GET_TAGS_LOADING", payload: false });
    } catch (error) {
        yield put({ type: "GET_TAGS_ERROR", error: error.data });
        yield put({ type: "GET_TAGS_LOADING", payload: false });

        log.info(error);
    }
}

export function* getTagWatcher() {
    yield takeLatest("GET_ITEMS_BOX", getItemsBox);
    yield takeLatest("GET_ITEMS", getItems);
    yield takeLatest("GET_TAG", getTag);
}
